import { ArrowUp } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer data-testid="footer-section" className="border-t border-white/5 bg-navy-950/60">
            <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
                <div className="grid gap-12 lg:grid-cols-12">
                    <div className="lg:col-span-5">
                        <img
                            src="/adminlogic-logo-dark.png"
                            alt="Admin Logic Services Ltd"
                            data-testid="footer-company-name"
                            className="h-20 w-auto"
                        />
                        <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
                            Dependable business administration and back-office support for UK
                            companies — precise, discreet and always on time.
                        </p>
                    </div>

                    <div className="lg:col-span-3">
                        <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-amber-400">
                            Explore
                        </p>
                        <ul className="mt-5 space-y-3 text-sm text-slate-400">
                            {[
                                ["Services", "#services"],
                                ["Approach", "#approach"],
                                ["Why Us", "#why-us"],
                                ["Contact", "#contact"],
                            ].map(([label, href]) => (
                                <li key={href}>
                                    <a
                                        href={href}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            scrollToId(href);
                                        }}
                                        className="transition-colors duration-300 hover:text-white"
                                    >
                                        {label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-4">
                        <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-amber-400">
                            Registered office
                        </p>
                        <address
                            data-testid="footer-registered-address"
                            className="mt-5 text-sm not-italic leading-relaxed text-slate-400"
                        >
                            Admin Logic Services Ltd
                            <br />
                            71-75 Shelton Street, Covent Garden,
                            <br />
                            London, WC2H 9JQ
                        </address>
                        <p
                            data-testid="footer-company-number"
                            className="mt-4 font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500"
                        >
                            Company No. 17432590
                        </p>
                    </div>
                </div>

                <div className="mt-16 flex flex-col items-start justify-between gap-6 border-t border-white/5 pt-8 sm:flex-row sm:items-center">
                    <p className="text-xs text-slate-600">
                        © {year} Admin Logic Services Ltd. Registered in England &amp; Wales.
                    </p>
                    <button
                        data-testid="footer-back-to-top"
                        onClick={() => scrollToId("#hero")}
                        className="group flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500 transition-colors duration-300 hover:text-amber-400"
                    >
                        Back to top
                        <ArrowUp className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-1" />
                    </button>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
